<template>
  <div class="layout-page">
    <bottom></bottom>
    <div class="cat-head shelf-head">
      <ul class="cat-sex">
        <li class="left" :class="{active: getActive() === 'history'}">
          <a @click="toHistory">最近阅读</a>
        </li>
        <li class="right" :class="{active: getActive() === 'shelf'}">
          <a @click="toShelf">我的书架</a>
        </li>
      </ul>
    </div>
    <div id="scroll-div-shelf" class="scroll-list aui-scrollView">
      <div class="shelf-list">
        <template v-if="activated === 'shelf'">
          <books-shelf type="shelf" :show-more="false" :books="shelfList" @remove-book="removeBook"></books-shelf>
          <van-empty v-if="shelfList.length === 0 " description="暂无书架" />
        </template>
        <template v-if="activated === 'history'">
          <books-shelf type="history" :show-more="false" :books="historyList"></books-shelf>
          <van-empty v-if="historyList.length === 0" description="暂无阅读" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import BooksShelf from '@/components/share/books-shelf'
import Bottom from '@/components/layer1/bottom'

import shelfService from '../../services/shelfService'

export default {
  name: 'shelf',
  data () {
    return {
      componentName: '',
      activated: 'history',
      shelfList: [],
      historyList: []
    }
  },
  methods: {
    getActive () {
      return this.activated
    },
    toShelf () {
      this.loadShelf()
      this.activated = 'shelf'
    },
    toHistory () {
      this.loadHistory()
      this.activated = 'history'
    },
    loadShelf () {
      this.shelfList = shelfService.getShelf()
    },
    loadHistory () {
      this.historyList = shelfService.getHistory()
    },
    removeBook (book) {
      // this.$dialog.confirm({
      //   title: '提示',
      //   message: ''
      // })
      shelfService.addShelf(book)
      this.loadShelf()
    }
  },
  components: {
    'books-shelf': BooksShelf,
    bottom: Bottom
  },
  mounted () {
    this.componentName = this.$route.name
    if (
      this.$store.state.pageState[this.componentName] &&
      this.$router.isBack
    ) {
      Object.assign(
        this.$data,
        this.$store.state.pageState[this.$route.name].data
      )
      setTimeout(() => {
        const scrollDiv = document.getElementById('scroll-div-shelf')
        scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top
      }, 0)
    } else {
      this.loadShelf()
      this.loadHistory()
      // this.toShelf()
      if (this.$route.query.active === 'history') {
        this.toHistory()
      }
    }
    this.$router.isBack = true
  },
  beforeDestroy () {
    const scrollDiv = document.getElementById('scroll-div-shelf')
    const state = {}
    state[this.componentName] = { data: this.$data, top: scrollDiv.scrollTop }
    this.$store.commit('saveState', state)
  }
}
</script>
